<template>
    <div class="">
        <div class="text-right">
            <!-- @click="scrollPositionToTop" -->
            <q-btn unelevated flat v-if="ShowCancelButton" :label='$t("common.cancel")' class="q-mr-sm" :color="CancelButtonColor" :text-color="CancelButtonTextColor"  @click="CancelButton();scrollPositionToTop();" :disable="DisableCancelButton" />

            <q-btn unelevated v-if="ShowBackButton" label="Back" class="q-mr-sm " :color="BackButtonColor" :text-color="BackButtonTextColor"  @click="BackButton();scrollPositionToTop();" :disable="DisableBackButton" />
            <!-- <q-btn v-if="ShowBackButton" icon="fas fa-caret-left" class="q-mr-sm mobile-only" :color="BackButtonColor" :text-color="BackButtonTextColor"  @click="BackButton()" :disable="DisableBackButton"/> -->
            
            <q-btn unelevated v-if="ShowPrintButton" :label='$t("common.PrintBtn")' class="desktop-only" @click="PrintButton();" :disable="DisablePrintButton" style="background-color: #ff6666; color: #fff"/>
            <q-btn unelevated v-if="ShowPrintButton" :label='$t("common.PrintBtn")' class="mobile-only"  @click="PrintButton();" :disable="DisablePrintButton" style="background-color: #ff6666; color: #fff"/>
            
            <q-btn unelevated v-if="ShowNextButton" :label='$t("common.continueBtn")' class="" :color="NextButtonColor" :text-color="NextButtonTextColor" @click="NextButton(); scrollPositionToTop();" :disable="DisableNextButton"/>
            <!-- <q-btn v-if="ShowNextButton" icon="fas fa-caret-right" class="mobile-only" :color="NextButtonColor" :text-color="NextButtonTextColor" @click="NextButton()" :disable="DisableNextButton"/> -->
            
            <q-btn unelevated v-if="ShowBackToButton" :label='$t("common.BackToIakaun")'  :color="BackToButtonColor" :text-color="BackToButtonTextColor" @click="BackToButton();scrollPositionToTop();" :disable="DisableBackToButton"/>
            <q-btn unelevated v-if="ShowBackToIAccessButton" label="Back To i-Access"  :color="BackToIAccessButtonColor" :text-color="BackToIAccessButtonTextColor" @click="BackToIAccessButton();scrollPositionToTop();" :disable="DisableBackToIAccessButton"/>
           
           <q-btn unelevated v-if="ShowConfirmButton" label="Confirm" class="" :color="ConfirmButtonColor" :text-color="ConfirmButtonTextColor" @click="ConfirmButton();scrollPositionToTop();" :disable="DisableConfirmButton"/>
            <q-btn unelevated v-if="ShowSubmitButton" :label='$t("common.submit")' :color="SubmitButtonColor" :text-color="SubmitButtonTextColor" @click="SubmitButton();scrollPositionToTop();" :disable="DisableSubmitButton"/>
            <q-btn unelevated v-if="ShowTACButton" label="Send TAC" :color="ShowTACButtonColor" :text-color="ShowTACTextColor" @click="ShowTAC();" :disable="DisableShowTACButton"/>
            <q-btn unelevated v-if="ShowAddToCartButton" :label='$t("Buy.AddToCart")' :color="AddToCartButtonColor" :text-color="AddToCartButtonTextColor" @click="AddToCartButton();" :disable="DisableAddToCartButton" style="background: #ff6666 !important;"/>
            
            <q-btn unelevated v-if="ShowAgreeButton" :label='$t("common.Agree")' :color="AgreeButtonColor" :text-color="AgreeButtonTextColor" @click="AgreeButton();scrollPositionToTop();" :disable="DisableAgreeButton" style="background: #ff6666 !important;"/>
            <q-btn unelevated v-if="ShowDisagreeButton" :label='$t("common.Disagree")' :color="DisagreeButtonColor" :text-color="DisagreeButtonTextColor" @click="DisagreeButton();scrollPositionToTop();" :disable="DisableDisagreeButton"/>
        </div>
    </div>
</template>

<script>
import store from '../store'; // only use for calling states
import { mapActions } from "vuex"; // only use for calling actions
export default {
    props: [
        'ShowPrintButton',
        'DisablePrintButton',
        'PrintButtonColor',
        'PrintButtonTextColor',
        'ShowNextButton',
        'ShowBackToButton',
        'ShowBackToIAccessButton',
        'DisableBackToIAccessButton',
        'DisableBackToButton',
        'BackToButtonColor',
        'BackToButtonTextColor',
        'DisableNextButton',
        'NextButtonColor',
        'NextButtonTextColor',
        'ShowSubmitButton',
        'ShowTACButton',
        'ShowTACTextColor',
        'ShowTACButtonColor',
        'DisableSubmitButton',
        'DisableShowTACButton',
        'SubmitButtonColor',
        'SubmitButtonTextColor',
        'ShowBackButton',
        'DisableBackButton',
        'BackButtonColor',
        'BackButtonTextColor',
        'ShowCancelButton',
        'DisableCancelButton',
        'CancelButtonColor',
        'CancelButtonTextColor',
        'ShowConfirmButton',
        'DisableConfirmButton',
        'DisableSubmitButton',
        'ConfirmButtonColor',
        'ConfirmButtonTextColor',
        'ShowAgreeButton',
        'DisableAgreeButton',
        'AgreeButtonColor',
        'AgreeButtonTextColor',
        'ShowDisagreeButton',
        'DisableDisagreeButton',
        'DisagreeButtonColor',
        'DisagreeButtonTextColor',
        'ShowAddToCartButton',
        'DisableAddToCartButton',
        'AddToCartButtonColor',
        'AddToCartButtonTextColor',
    ],
    components: {
    },
    data() {
        return {
        
        }
    },
    methods : {
        scrollPositionToTop(){
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        SkipButton(){
            this.$emit('SkipButton')
        },
        BackToButton(){
            this.$emit('BackToButton')
        },
        BackToIAccessButton(){
            this.$emit('BackToIAccessButton')
        },
        NextButton(){
            this.$emit('NextButton')
        },
        SubmitButton(){
            this.$emit('SubmitButton')
        },
        ShowTAC(){
            this.$emit('ShowTAC')
        },
        AddToCartButton(){
            this.$emit('AddToCartButton')
        },
        ConfirmButton(){
            this.$emit('ConfirmButton')
        },
        BackButton(){
            this.$emit('BackButton')
        },
        CancelButton(){
            this.$emit('CancelButton')
        },
        PrintButton(){
            this.$emit('PrintButton')
        },
        AgreeButton(){
            this.$emit('AgreeButton')
        },
        DisagreeButton(){
            this.$emit('DisagreeButton')
        }
    },
    mounted(){
        
    }
}
</script>
        